/* eslint-disable no-console */
import { React, useState, useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import DashboardIcon from '@material-ui/icons/Dashboard'
import Divider from '@material-ui/core/Divider'
import styled from 'styled-components'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import dashboardData from './data.json'
import { sendMessage } from '../../../utils/iframeUtil'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: inherit;
`
const StyledTextField = styled(TextField)`
  padding: 0px 15px 0px 10px;
  width: 100%;
`
const StyledFilterSection = styled.div`
  width: 100%;
  background: #303030;
`
const StyledList = styled(List)`
  overflow-y: scroll;
`

const DashboardNavigator = () => {
  const [dashboardScope, setDasbhoardScope] = useState('ALL')
  const [filterText, setFilterText] = useState('')
  const [dashboardList, setDashboardList] = useState([])
  const dashboardScopeOptions = [
    {
      value: 'ALL',
      label: 'All Dashboards'
    },
    {
      value: 'MY',
      label: 'My Dashboards'
    },
    {
      value: 'COMPANY',
      label: 'Company Dashboards'
    },
    {
      value: 'TEMP',
      label: 'My Company'
    }
  ]
  const handleChange = (e) => {
    setDasbhoardScope(e.target.value)
  }
  const theme = createTheme({
    palette: {
      type: 'dark'
    },
    // TODO: should not have to define again
    typography: {
      fontFamily: [
        'IBM Plex Sans',
        '-apple-system',
        'BlinkMacSystemFont',
        'Segoe UI',
        'Roboto',
        'Oxygen',
        'Ubuntu',
        'Cantarell',
        'Fira Sans',
        'Droid Sans',
        'Helvetica Neue',
        'sans-serif'
      ].join(',')
    }
  })

  const onLinkClick = (type, data) => () => sendMessage({ type, data })
  const onInputChange = (e) => {
    setFilterText(e.target.value)
  }

  useEffect(() => {
    // TODO: need to fix the performance issue of filtering/rendering a long list
    const timeoutId = setTimeout(() => {
      const filterdList = dashboardData.filter((dashboard) =>
        dashboard.name.toUpperCase().includes(filterText.toUpperCase())
      )
      setDashboardList(filterdList)
    }, 500)
    return () => clearTimeout(timeoutId)
  }, [filterText])

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <StyledContainer>
        <StyledFilterSection>
          <StyledTextField
            select
            label="Select"
            value={dashboardScope}
            margin="normal"
            onChange={handleChange}
            variant="outlined">
            {dashboardScopeOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledTextField>
          <StyledTextField
            variant="outlined"
            required
            label="Search dashboards"
            margin="normal"
            onChange={onInputChange}
            value={filterText}
          />
          <Divider />
        </StyledFilterSection>
        <StyledList component="nav">
          {dashboardList.map((dashboard) => (
            <ListItem
              button
              key={dashboard.dashboardId}
              onClick={onLinkClick('gotoDashboard', dashboard.dashboardId)}>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary={dashboard.name} />
            </ListItem>
          ))}
        </StyledList>
      </StyledContainer>
    </MuiThemeProvider>
  )
}

export default DashboardNavigator
